"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _components = require("../components");

var _useModal2 = require("../lib/utils/hooks/useModal");

var _Layout = require("./Layout.style");

var _Navbar = _interopRequireDefault(require("./Navbar"));

var _Sidebar = _interopRequireDefault(require("./Sidebar"));

var _Footer = _interopRequireDefault(require("./Footer"));

var Layout = function Layout(_ref) {
  var children = _ref.children,
      fileName = _ref.fileName,
      currentDocument = _ref.currentDocument,
      requestPatientRecord = _ref.requestPatientRecord,
      isNewRecordAvailable = _ref.isNewRecordAvailable,
      rowsToExport = _ref.rowsToExport,
      resetRowsSelection = _ref.resetRowsSelection,
      rawDocument = _ref.rawDocument,
      ehrRecord = _ref.ehrRecord,
      documentTitle = _ref.documentTitle,
      exportCDAAsPDF = _ref.exportCDAAsPDF,
      exportCDAAsPDFLoading = _ref.exportCDAAsPDFLoading,
      setExportCDAAsPDFLoading = _ref.setExportCDAAsPDFLoading;

  var _useModal = (0, _useModal2.useModal)(),
      toggle = _useModal.toggle,
      isShowing = _useModal.isShowing;

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var attachments = currentDocument.attachments,
      searchData = currentDocument.searchData;

  var toggleExpand = function toggleExpand() {
    setExpanded(!expanded);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Navbar.default, {
    toggleExpand: toggleExpand,
    expanded: expanded,
    attachmentData: attachments,
    searchData: searchData,
    toggle: toggle
  }), /*#__PURE__*/_react.default.createElement(_Sidebar.default, {
    expanded: expanded,
    currentDocument: currentDocument,
    setExpanded: setExpanded,
    originalFileName: fileName,
    documentTitle: documentTitle,
    requestPatientRecord: requestPatientRecord,
    isNewRecordAvailable: isNewRecordAvailable,
    rowsToExport: rowsToExport,
    resetRowsSelection: resetRowsSelection,
    rawDocument: rawDocument,
    ehrRecord: ehrRecord,
    exportCDAAsPDF: exportCDAAsPDF,
    exportCDAAsPDFLoading: exportCDAAsPDFLoading,
    setExportCDAAsPDFLoading: setExportCDAAsPDFLoading
  }), /*#__PURE__*/_react.default.createElement(_Layout.Content, {
    expanded: expanded
  }, children)), /*#__PURE__*/_react.default.createElement(_Footer.default, null), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_useModal2.Modal, {
    isShowing: isShowing,
    hide: toggle
  }, /*#__PURE__*/_react.default.createElement(_components.AttachedDocs, {
    attachmentData: attachments
  }))));
};

var _default = Layout;
exports.default = _default;